module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "relative",
    attrs: {
      "id": "alertes"
    }
  }, [_c('button', {
    staticClass: "relative z-50 focus:outline-none",
    attrs: {
      "id": "toggle-alerts",
      "type": "button",
      "aria-label": "Voir les notifications"
    },
    on: {
      "click": _vm.toggleNotifs
    }
  }, [_c('i', {
    staticClass: "inline-block h-8 w-8 mask mask-cloche bg-white"
  }), _vm._v(" "), _c('span', {
    staticClass: "absolute -top-1 -right-1 w-5 h-5 bg-orange text-white text-xs flex items-center justify-center rounded-full font-bold"
  }, [_vm._v(_vm._s(_vm.nbNotifs))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isOpen && _vm.nbNotifs > 0),
      expression: "isOpen && nbNotifs > 0"
    }],
    staticClass: "fixed top-16 left-1/2 -translate-x-1/2 w-[90vw] sm:w-96 bg-white text-black rounded-xl shadow-lg z-50 overflow-x-hidden overflow-y-auto max-h-[75vh] border-2 border-secondary",
    attrs: {
      "id": "notif-popover"
    }
  }, [_c('ul', {
    staticClass: "list-alertes divide-y divide-gray-200 px-4"
  }, [_vm._l((_vm.orderBy(_vm.warningsOutil, 'diff', 'desc')), function(notif) {
    return _c('li', {
      key: notif.id,
      staticClass: "flex items-start gap-4 py-3 min-w-0 -mx-4 px-4",
      staticStyle: {
        "background-color": "rgba(194, 221, 255, 0.4)"
      }
    }, [_c('i', {
      staticClass: "shrink-0 inline-block h-6 w-6 mask mt-1",
      class: [
        'mask-' + notif.type_notif,
        notif.type_notif === 'error' ? 'bg-error' : '',
        notif.type_notif === 'warning' ? 'bg-warning' : ''
      ]
    }), _vm._v(" "), _c('div', {
      staticClass: "flex flex-col gap-1 min-w-0 flex-1 break-words"
    }, [_c('p', {
      class: [
        notif.type_notif === 'error' ? 'text-error' : '',
        notif.type_notif === 'warning' ? 'text-warning' : ''
      ]
    }, [_vm._v("\n                        Expire le "), _c('strong', [_vm._v(_vm._s(_vm._f("dateFormat")(notif.date_butoir)))])]), _vm._v(" "), _c('p', [_vm._v("\n                        " + _vm._s(notif.type_outil.nom) + "\n                        "), _c('strong', [_vm._v(_vm._s(notif.modele) + " " + _vm._s(notif.marque))])])])])
  }), _vm._v(" "), _vm._l((_vm.errorsOutil), function(notif) {
    return _c('li', {
      key: notif.id,
      staticClass: "flex items-start gap-4 py-3 min-w-0 -mx-4 px-4",
      staticStyle: {
        "background-color": "rgba(194, 221, 255, 0.4)"
      }
    }, [_c('i', {
      staticClass: "shrink-0 inline-block h-6 w-6 mask mt-1",
      class: [
        'mask-' + notif.type_notif,
        notif.type_notif === 'error' ? 'bg-error' : '',
        notif.type_notif === 'warning' ? 'bg-warning' : ''
      ]
    }), _vm._v(" "), _c('div', {
      staticClass: "flex flex-col gap-1 min-w-0 flex-1 break-words"
    }, [_c('p', {
      class: [
        notif.type_notif === 'error' ? 'text-error' : '',
        notif.type_notif === 'warning' ? 'text-warning' : ''
      ]
    }, [_vm._v("\n                        Expiré le "), _c('strong', [_vm._v(_vm._s(_vm._f("dateFormat")(notif.date_butoir)))])]), _vm._v(" "), _c('p', [_vm._v("\n                        " + _vm._s(notif.type_outil.nom) + "\n                        "), _c('strong', [_vm._v(_vm._s(notif.modele) + " " + _vm._s(notif.marque))])])])])
  }), _vm._v(" "), _vm._l((_vm.orderBy(_vm.errorsBouteille, 'diff', 'desc')), function(notif) {
    return _c('li', {
      key: notif.id,
      staticClass: "flex items-start gap-4 py-3 min-w-0 -mx-4 px-4",
      staticStyle: {
        "background-color": "rgba(231, 237, 247, 0.4)"
      }
    }, [_c('i', {
      staticClass: "shrink-0 inline-block h-6 w-6 mask mt-1",
      class: [
        'mask-' + notif.type_notif,
        notif.type_notif === 'error' ? 'bg-error' : '',
        notif.type_notif === 'warning' ? 'bg-warning' : ''
      ]
    }), _vm._v(" "), _c('div', {
      staticClass: "flex flex-col gap-1 min-w-0 flex-1 break-words"
    }, [_c('p', {
      class: [
        notif.type_notif === 'error' ? 'text-error' : '',
        notif.type_notif === 'warning' ? 'text-warning' : ''
      ]
    }, [_vm._v("\n                        Retard retour de "), _c('strong', [_vm._v(_vm._s(Math.floor(notif.diff)) + " jour(s)")])]), _vm._v(" "), _c('p', [_vm._v("\n                        Bouteille " + _vm._s(notif.type) + " "), _c('strong', [_vm._v(_vm._s(notif.code))])])])])
  }), _vm._v(" "), _vm._l((_vm.orderBy(_vm.warningsBouteille, 'diff', 'desc')), function(notif) {
    return _c('li', {
      key: notif.id,
      staticClass: "flex items-start gap-4 py-3 min-w-0 -mx-4 px-4",
      staticStyle: {
        "background-color": "rgba(231, 237, 247, 0.4)"
      }
    }, [_c('i', {
      staticClass: "shrink-0 inline-block h-6 w-6 mask mt-1",
      class: [
        'mask-' + notif.type_notif,
        notif.type_notif === 'error' ? 'bg-error' : '',
        notif.type_notif === 'warning' ? 'bg-warning' : ''
      ]
    }), _vm._v(" "), _c('div', {
      staticClass: "flex flex-col gap-1 min-w-0 flex-1 break-words"
    }, [_c('p', {
      class: [
        notif.type_notif === 'error' ? 'text-error' : '',
        notif.type_notif === 'warning' ? 'text-warning' : ''
      ]
    }, [_vm._v("\n                        Retour dans "), _c('strong', [_vm._v(_vm._s(Math.abs(Math.floor(notif.diff))) + " jour(s)")])]), _vm._v(" "), _c('p', [_vm._v("\n                        Bouteille " + _vm._s(notif.type) + " "), _c('strong', [_vm._v(_vm._s(notif.code))])])])])
  })], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-602329b6","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/NotifBar.vue
// module id = 1035
// module chunks = 0